.loading-left(style="position: absolute;left: 50%;margin-left: 35px;")= message
.loading(style="position:relative")
  .l1
    div
  .l2
    div
  .l3
    div
  .l4
    div